module.exports = __webpack_public_path__ + "fonts/3b787e0.otf";